import { React, useEffect, useState } from "react";
import "./document-status-update.scss";
import dayjs from "dayjs";
import { Row, Col, Space, Divider, Button, Modal, Form, Spin, Popover, DatePicker  } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import editNotebook from '../../assets/images/document-status-update-editNotebook.svg';
import uploadArrow from '../../assets/images/document-status-update-UploadArrow.svg';
import cancle from '../../assets/images/document-status-update-cancel.svg';
import * as orderService from "../../service/order/orderService";
import { checkIsAllowMultiCurrencySupport } from "../../util/multiCurrencyUtility";
import { useParams } from "react-router-dom";
import Fileupload from "../../common/fileupload/fileupload";
import NodataImg from "../../assets/images/nodata-img.svg";
import { DocTypes, EntityTypes, OrderDocStatus,CommonConstants } from "../../constants/commonConstants";
import notification from "../../service/notification";
import moment from "moment";
import { checkIsInternalSourcing, checkIsTurkeyKazak } from "../../util/constantUtility";
import { useStore } from "../../store/store";
import DecimalFormatter from "../../common/decimal-converter/decimal-converter";
import infoicon from '../../assets/images/info-icon.svg'
import pendingInfoIcon from '../../assets/images/info.svg'
import rejectedInfoIcon from '../../assets/images/info-rejected.svg';
import successInfoIcon from '../../assets/images/success-info.svg';
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import * as localStorageService from "../../service/localStorageService";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import dayjsPluginUTC from "dayjs-plugin-utc";


const DocumentStatus = () => {
    const isAISuggestion = useLocation().search.replace("?", "") === "true";
   dayjs.extend(dayjsPluginUTC);
    const { user, saveUser } = useStore();
    const [editModel, setEditModel] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null);
    const [value, setValue] = useState('');
    const [statusList, setStatusList] = useState([]);
    console.log("statusList",statusList)
    const [resStatusList, setResStatusList] = useState([]);
    const [orderDetails, setOrderDetails] = useState(null);
    const [lineItemUploadModal, setLineItemUploadModal] = useState(false)
    const [uploadLoader, setUploadLoader] = useState(false);
    const [uploadStatusLoader, setUploadStatusLoader] = useState(false);
    const [statusDocUpdateLoader, setStatusDocUpdateLoader] = useState(false);
    const [loader, setLoader] = useState(true);
    const [lineItemLoader, setLineItemLoader] = useState(false);
    let { orderId, tripId } = useParams();
    const [uploadDocsForm] = Form.useForm();
    const [currentStatusIndex, setCurrentStatusIndex] = useState(0);
    console.log('currentStatusIndex',currentStatusIndex)
    const [isViewSubmittedDocuments, setIsViewSubmittedDocuments] = useState(false);
    const [selectedStatusDetails, setSelectedStatusDetails] = useState({ index: null, status: null });
    console.log('selectedStatusDetails',selectedStatusDetails)
    const [orderDetailLoader, setOrderDetailLoader] = useState(true);
    const [eddValue, setEddValue] = useState(null);
    const [lineItems, setLineItems] = useState([]);
    const [selectedLineItems, setSelectedLineItems] = useState(null);
    const [addDocs, setAddDocs] = useState([{
        isInsertUpdate: false,
        isDeleted: false,
        documentPath: "",
        documentPathThumb: "",
        fileName: "",
        lbDocId: ""
    }]);
    console.log("addDocs",addDocs)
    const [addLineDocs, setAddLineDocs] = useState([{
        isInsertUpdate: true,
        isDeleted: false,
        documentPath: "",
        documentPathThumb: "",
        fileName: "",
        lbDocId: "",
    }]);
    const [documentsSubmitted, setDocumentsSubmitted] = useState(false);
    const checkuploadeddocs = ""
    const format = "DD/MM/YYYY, hh:mm A";
    const [Eddform] = Form.useForm();
    const [isUploadMode, setIsUploadMode] = useState(false);
    const [remountKey, setRemountKey] = useState(0);

    useEffect(() => {
        getStatusList();
        getOrderDetails();
        getLineItems();

    }, [])

useEffect(() => {
  if (remountKey > 0) {
    getStatusList();
    getOrderDetails();
  }
}, [remountKey]);

    const getOrderDetails = () => {
        const languageISOCode=localStorageService.getValue(LocalStorageKeys.Lang) ? localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode;
        setOrderDetailLoader(true);
        orderService.getOrderDetails(orderId,languageISOCode)
            .then((res) => {
                setOrderDetailLoader(false);
                setOrderDetails(res?.data?.data)
            })
            .catch((err) => {
                console.error("Error while getting order detail data", err);
            })
    }

    const getStatusList = () => {
        const languageISOCode=localStorageService.getValue(LocalStorageKeys.Lang) ? localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode;
        setLoader(true);
        orderService.getStatusList(orderId, tripId,languageISOCode)
            .then((res) => {
                if (res.status === 200) {
                    setLoader(false);
                    setStatusList(res?.data?.data);
                    setResStatusList(res?.data?.data);
                    const currentStatus = res?.data?.data.findLastIndex((item) => item.isCompleted === true);
                    setCurrentStatusIndex(currentStatus)
                     const tripEDDItem = res?.data?.data?.find((item) => item?.statusName === "At Loading" || item?.localizeStatusName === "At Loading");
                    if (tripEDDItem?.tripEDD) {
                        if(tripEDDItem?.tripEDD != "0001-01-01T00:00:00Z"){
                         Eddform?.setFieldValue("eddDate",dayjs.utc(tripEDDItem.tripEDD)); 
                         setEddValue(tripEDDItem.tripEDD);
                        }
                    }
                }
            })
            .catch((err) => {
                console.error("Error while getting status list data", err);
            })
    }

    const getLineItems = () => {
        setLineItemLoader(true);
        orderService.getLineItemsDocumentDetails(orderId, tripId)
            // orderService.getLineItemsDocumentDetails('ORD24250007073', '67b180a062779f92ddbf2094')
            .then((res) => {
                if (res.status === 200) {
                    setLineItemLoader(false);
                    setLineItems(res?.data?.data?.costLineItemsRes)
                }
            })
            .catch((err) => {
                console.error("Error while getting line items", err);
            })
    }

    const handleChange = (e) => {
        const inputValue = e.target.value;
        // Check if the input value is a valid integer
        if (/^-?\d*$/.test(inputValue)) {
            setValue(inputValue);  // Update state if the input is a valid integer
        }
    };

    const handleStatusChange = (item, index) => {
        if (checkIsInternalSourcing(user?.userRole)) {

        }
        else {
            setAddDocs([{
                isInsertUpdate: false,
                isDeleted: false,
                documentPath: "",
                documentPathThumb: "",
                fileName: "",
                lbDocId: "",
            }]);
            const updatedData = statusList.map((item, i) => {
                if (i === index) {
                    return { ...item, isCompleted: !item.isCompleted };
                }
                return item;
            });
            setStatusList(updatedData);
            setSelectedStatusDetails({ index, status: item });
            setDocumentsSubmitted(false);
            setIsViewSubmittedDocuments(false);
            setIsUploadMode(false);
        }
    };


    const openModal = () => {
        setEditModel(true);
    };

    const closeModal = () => {
        setEditModel(false);
    };

    const handleEditClick = (item) => {
        setSelectedItem(item);
        setEditModel(true);
    };

    const onFileUploadDocs = (file, index) => {
        const updatedDocs = [...addDocs];
        updatedDocs[index] = {
            ...updatedDocs[index],
            documentPath: file.FileURL,
            documentPathThumb: file.FileThumbURL,
            fileName: file.FileName,
            isInsertUpdate: file.FileURL ? true : false,
            isDeleted: false,
            lbDocId: ""

        };
        setAddDocs(updatedDocs);
    };

    const onFileUploadLineItemdocs = (file, index) => {
        const updatedDocs = [...addLineDocs];
        updatedDocs[index] = {
            ...updatedDocs[index],
            documentPath: file.FileURL || updatedDocs[index]?.documentPath,
            documentPathThumb: file.FileThumbURL || updatedDocs[index]?.documentPathThumb,
            fileName: file.FileName || updatedDocs[index]?.fileName,
            isInsertUpdate: true,
            isDeleted: false,
            lbDocId: "",

        };
        setAddLineDocs(updatedDocs);
    };


    const addDocHandler = () => {
        setAddDocs([...addDocs, {
            isInsertUpdate: true,
            isDeleted: false,
            documentPath: "",
            documentPathThumb: "",
            fileName: "",
            lbDocId: "",
        }])
    }

    const addLineDocHandler = () => {
        setAddLineDocs([...addLineDocs, {
            isInsertUpdate: true,
            isDeleted: false,
            documentPath: "",
            documentPathThumb: "",
            fileName: "",
            lbDocId: "",
        }])
    }

const disabledPastDate = (current) => {
  return current && current < moment().startOf("day");
};
    const statusSubmitHandler = () => {
        Eddform.validateFields().then(() => {
        const isSubmissionBlocked = (statusList[selectedStatusDetails?.index]?.documentStatus == "Rejected" && (
            !addDocs[0]?.documentPath || !addDocs[0].isInsertUpdate)) ||
            (statusList[selectedStatusDetails?.index]?.documentStatus != "Rejected" &&
                (!statusList[selectedStatusDetails?.index]?.isCompleted || isViewSubmittedDocuments
                    || (statusList[selectedStatusDetails?.index]?.isMust && !addDocs[0]?.documentPath)));

        if (isSubmissionBlocked) {
            return;
        }
        else {
            if (statusList[selectedStatusDetails?.index]?.documentStatus != "Rejected") {
                let payload = {
                    "tripId": tripId,
                    "orderNumber": orderId,
                    "etaDate": orderDetails?.etaDate ?? null,
                    "completedDateTime": null,
                    "status": selectedStatusDetails?.status?.statusName,
                    "remarks": "",
                    "createdBy": user?.userId,
                    "tripETA": null,
                    "actualDocs": addDocs.filter((doc) => doc.documentPath),
                    "isAISuggestion":isAISuggestion,
                    "tripEDD":(eddValue && !checkIsStatusRestrictionForEdd(selectedStatusDetails))? eddValue?.includes("Z") ? eddValue : eddValue+"Z": null,


                }
                setUploadStatusLoader(true);
                orderService.changeTripStatus(payload)
                    .then((res) => {
                        if (res?.status === 200) {
                            setUploadStatusLoader(false);
                            notification.success(t("STATUS_UPDATED_SUCCESS"));
                            getStatusList();
                            getOrderDetails();
                            getLineItems();
                            setAddDocs([{
                                isInsertUpdate: true,
                                isDeleted: false,
                                documentPath: "",
                                documentPathThumb: "",
                                fileName: "",
                                lbDocId: "",
                            }]);
                            setSelectedStatusDetails({ index: null, status: null });
                        }
                    })
                    .catch((err) => {
                        setUploadStatusLoader(false);
                    })
            }
            else {
                let payload = {
                    "tripId": tripId,
                    "orderNumber": orderId,
                    "etaDate": orderDetails?.etaDate ?? null,
                    "completedDateTime": null,
                    "status": selectedStatusDetails?.status?.statusName,
                    "remarks": "",
                    "createdBy": "",
                    "tripETA": null,
                    "actualDocs": addDocs,
                }
                setUploadStatusLoader(true);
                orderService.reUploadTripStatusDocument(payload)
                    .then((res) => {
                        if (res?.status === 200) {
                            setUploadStatusLoader(false);
                            notification.success(t("DOC_REPUDIATED_SUCCESS"));
                            getStatusList();
                            getOrderDetails();
                            getLineItems();
                            setAddDocs([{
                                isInsertUpdate: false,
                                isDeleted: false,
                                documentPath: "",
                                documentPathThumb: "",
                                fileName: "",
                                lbDocId: "",
                            }]);
                            setSelectedStatusDetails({ index: null, status: null });
                        }
                    })
                    .catch((err) => {
                        setUploadStatusLoader(false);
                    })
            }
            // }
        }
    })
          .catch(() => {
            notification.error(t("CORRECTION_FORM_ERROR"));
          });
    };

    const onClickUploadHandler = (item) => {
        setLineItemUploadModal(true);
        setSelectedLineItems(item);

        const updatedDocs = [];

        item?.document?.forEach((file) => {
            updatedDocs.push({
                documentPath: file.documentPath || "",
                documentPathThumb: file.documentPathThumb || "",
                fileName: file.fileName || "",
                isInsertUpdate: false,
                isDeleted: false,
                lbDocId: "",
            });
        });
        if (updatedDocs.length === 0) {
            updatedDocs.push({
                isInsertUpdate: true,
                isDeleted: false,
                documentPath: "",
                documentPathThumb: "",
                fileName: "",
                lbDocId: "",
            })
        }
        setAddLineDocs(updatedDocs);
    };


    const SaveLineItemDocsHandler = () => {
        // if (!addLineDocs[0]?.documentPath) {
        //     notification.warning("warning", "Please upload documents before submitting.");
        // } 
        // else {
        let payload = {
            orderNumber: orderId,
            tripId: tripId,
            lineItems: [
                {
                    lineItemId: selectedLineItems?.lineItemId,
                    document: addLineDocs,
                    lineItemDocStatus: selectedLineItems?.lineItemDocStatus,
                    remarks: "",
                }
            ],
                  "isAISuggestion":isAISuggestion

        }
        setUploadLoader(true);
        orderService.addLineItemDocuments(payload)
            .then((res) => {
                if (res?.status === 200) {
                    setLineItemUploadModal(false);
                    setUploadLoader(false);
                    notification.success(t("STATUS_UPDATED_SUCCESS"));
                    getStatusList();
                    getOrderDetails();
                    getLineItems();
                }
            })
            .catch((err) => {
                setUploadLoader(false);
            })
    };

    const reUploadTripStatusDocuments = () => {
        const payload = {
            tripId: tripId,
            orderNumber: orderId,
            etaDate: "",
            completedDateTime: "",
            status: "",
            remarks: "",
            createdBy: "",
            actualDocs: addLineDocs,
            tripETA: "",
        };

        orderService.reUploadTripStatusDocuments(payload)
            .then((res) => {
                if (res?.status === 200) {
                    notification.success(t("STATUS_UPDATED_SUCCESS"));
                    getStatusList();
                    getOrderDetails();
                    getLineItems();
                }
            })
            .catch((err) => {

            });
    };


    const deleteTripStatusDoocumentsHandler = () => {
        const payload = {
            tripId: tripId,
            orderNumber: orderId,
            status: "",
            documentId: "",
        };

        orderService.deleteTripStatusDocuments(payload)
            .then((res) => {
                if (res?.status === 200) {
                    notification.success(t("STATUS_UPDATED_SUCCESS"));
                    getStatusList();
                    getOrderDetails();
                    getLineItems();
                }
            })
            .catch((err) => {

            });
    };

    const reUploadLineItemDocuments = () => {
        const payload = {
            tripId: tripId,
            orderNumber: orderId,
            etaDate: "",
            completedDateTime: "",
            status: "",
            remarks: "",
            createdBy: "",
            actualDocs: addLineDocs,
            tripETA: "",
        };

        orderService.reUploadLineItemDocuments(payload)
            .then((res) => {
                if (res?.status === 200) {
                    notification.success(t("STATUS_UPDATED_SUCCESS"));
                    getStatusList();
                    getOrderDetails();
                    getLineItems();
                }
            })
            .catch((err) => {

            });
    };


    const deleteLineItemDoocumentsHandler = () => {
        const payload = {
            tripId: tripId,
            orderNumber: orderId,
            status: "",
            documentId: "",
        };

        orderService.deleteLineItemDocuments(payload)
            .then((res) => {
                if (res?.status === 200) {
                    notification.success(t("STATUS_UPDATED_SUCCESS"));
                    getStatusList();
                    getOrderDetails();
                    getLineItems();
                }
            })
            .catch((err) => {

            });
    };

    const onChangeSelectedEDD= (value) => {
        let eddDate = value ? value?.format("YYYY-MM-DDTHH:mm:ss") : null;
          let finalEdd=eddDate ? eddDate+"Z":null;
        setEddValue(finalEdd);
    }

    const checkIsStatusRestrictionForEdd=(details)=>{
    const statusName =details?.status?.statusName?.trim()?.toLowerCase();
       if( statusName === "upcoming" ||
        statusName === "ready" ||
        statusName === "start for pick up"){
            return true;
        }else{
            return false;
        }
       
    }

    // statusSubmitHandler
    const submitHandlerStatus = async () => {
    try {
        if (!addDocs.some((doc) => doc.documentPath && !doc.isDeleted)) {
        return;
        }

        const payload = {
        orderNumber: orderId,
        tripId: tripId,
        status: selectedStatusDetails?.status?.statusName,
        documents: addDocs
            .filter((doc) => doc.documentPath && !doc.isDeleted)
            .map((doc) => ({
            isInsertUpdate: doc.isInsertUpdate,
            documentPath: doc.documentPath,
            documentPathThumb: doc.documentPathThumb,
            isDeleted: doc.isDeleted,
            fileName: doc.fileName,
            lastUpdatedBy: user?.userName || "",
            lbDocId: doc.lbDocId || "",
            })),
        };

        setStatusDocUpdateLoader(true);
        await orderService.postStatusDocUpdate(payload);
        setStatusDocUpdateLoader(false);
        setRemountKey((prev) => prev + 1);
        setIsUploadMode(false);
        setIsViewSubmittedDocuments(false);
        setAddDocs([
        {
            isInsertUpdate: false,
            isDeleted: false,
            documentPath: "",
            documentPathThumb: "",
            fileName: "",
            lbDocId: "",
        },
        ]);
    } catch (error) {
        console.error("Status document update failed", error);
        setStatusDocUpdateLoader(false);
    }
    };

    const isDisabledSubmit = !addDocs.some(
        (doc) => doc.documentPath && !doc.isDeleted
    );

    return (
        <div className="documentStatus-wrapper">
            <Row key={remountKey}>
                {/* Left side */}
                <Col span={16}>
                    <div className="left-side-container">
                        <div className="left-side-title">
                            {t("ORDER_TRIP_STATUS_UPDATE")}
                           {eddValue && (
                            <div
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                marginLeft: "8px",
                                gap: "4px",
                                verticalAlign: "middle",
                            }}
                            >
                            <span
                                style={{
                                color: "#f59e0b",
                                fontWeight: 500,
                                fontSize: "13px",
                                }}
                            >
                                {t("Estimated Delivery Date & Time")} :
                            </span>
                            <span
                                style={{
                                color: "#292929",
                                fontWeight: 500,
                                fontSize: "13px",
                                }}
                            >
                                {moment(eddValue).utc().format("Do MMM YYYY, hh:mm A")}
                            </span>
                            </div>
                        )}
                        </div>
                        {loader ?
                            <div className="loader">
                                <Spin />
                            </div>
                            :
                            <Row>
                                <Col span={12}>
                                    <div className="data-list">
                                        {statusList?.map((item, index) => (
                                            <>
                                                <div className={`data-item ${index === currentStatusIndex + 1 ? 'current-select-status' : ''}`} key={item.sequence}>
                                                    <div className={`data-box ${item.isCompleted ? "active" : "inactive"}`}>
                                                        <input
                                                            type="checkbox"
                                                            className={`radio-button ${item.isCompleted ? "active" : "inactive"} ${index === currentStatusIndex + 1 ? 'cursor-status' : ''}`}
                                                            checked={item.isCompleted}
                                                            onChange={() => handleStatusChange(item, index)}
                                                            disabled={index < currentStatusIndex || index > currentStatusIndex + 1 || index === currentStatusIndex}
                                                        />
                                                        <div className="status-list-container">
                                                            <span className={`status-id ${item.isCompleted ? 'status-black' : 'status-gray'}`}>
                                                                {/* {item.statusName}  */}
                                                                {item.localizeStatusName ? item.localizeStatusName:item.statusName} {item?.isMust && <span style={{ color: "red" }}>*</span>}
                                                            </span>
                                                            {/* ******* OLD LOGIC BEFORE Post-Status-Document-Update-Enhancement */}
                                                            {/* {(index <= currentStatusIndex && item.isCompleted && index !== 0 && (item.documents?.length > 0 || (item.documents.length === 1 && !item.documents[0]?.documentStatus) || item?.documentStatus === OrderDocStatus.REJECTED_DOC)) &&
                                                                <span className="sub-status" onClick={() => {
                                                                    setIsViewSubmittedDocuments(true);
                                                                    setStatusList(resStatusList);
                                                                    setSelectedStatusDetails({
                                                                        index,
                                                                        status: item
                                                                    });
                                                                    const documents = statusList[index].documents || [];
                                                                    setAddDocs(documents.map((doc) => ({
                                                                        ...doc,
                                                                        isInsertUpdate: false,
                                                                        isDeleted: false,
                                                                        lbDocId: "",
                                                                    })));
                                                                }}>
                                                                    {t("ORDER_DOCUMENT_SUBMITTED_DOCUMENTS")}
                                                                </span>
                                                            } */}
                                                            {/* *********** UPDATED LOGIC ::: Post-Status-Document-Update-Enhancement */}
                                                            {
                                                            index <= currentStatusIndex && item.isCompleted && index !== 0 && (
                                                                <>
                                                                {item.documents?.length > 0 ||
                                                                (item.documents?.length === 1 && !item.documents[0]?.documentStatus) ||
                                                                item?.documentStatus === OrderDocStatus.REJECTED_DOC ? (
                                                                    /* VIEW DOCUMENTS */
                                                                    <span
                                                                    className="sub-status"
                                                                    onClick={() => {
                                                                        setIsViewSubmittedDocuments(true);
                                                                        setIsUploadMode(false);
                                                                        setStatusList(resStatusList);
                                                                        setSelectedStatusDetails({
                                                                        index,
                                                                        status: item,
                                                                        });

                                                                        const documents = statusList[index]?.documents || [];
                                                                        setAddDocs(
                                                                        documents.map((doc) => ({
                                                                            ...doc,
                                                                            isInsertUpdate: false,
                                                                            isDeleted: false,
                                                                            lbDocId: "",
                                                                        }))
                                                                        );
                                                                    }}
                                                                    >
                                                                    {t("ORDER_DOCUMENT_SUBMITTED_DOCUMENTS")}
                                                                    </span>
                                                                ) : (
                                                                    /* UPLOAD DOCUMENTS */
                                                                    !['Upcoming', 'Start For Pick Up', 'At Loading'].includes(item.statusName) && (
                                                                    <span
                                                                    className="sub-status"
                                                                    onClick={() => {
                                                                        setIsViewSubmittedDocuments(true);
                                                                        setStatusList(resStatusList);
                                                                        setIsUploadMode(true);
                                                                        setSelectedStatusDetails({
                                                                        index,
                                                                        status: item,
                                                                        });
                                                                        // setAddDocs((prevDocs) => {
                                                                        //     const alreadyAdded = prevDocs.some((doc) => doc.isInsertUpdate !== true);
                                                                        //     if (alreadyAdded) return prevDocs;
                                                                        // });
                                                                        setAddDocs([
                                                                            {
                                                                            isInsertUpdate: false,
                                                                            isDeleted: false,
                                                                            documentPath: "",
                                                                            documentPathThumb: "",
                                                                            fileName: "",
                                                                            lbDocId: "",
                                                                            },
                                                                        ]);
                                                                    }}
                                                                    >
                                                                    Upload Documents
                                                                    </span>
                                                                    )
                                                                )}
                                                                </>
                                                            )
                                                            }

                                                            {/* Skipped Button*/}
                                                            {(index <= currentStatusIndex && !item.isCompleted) &&
                                                                <span className="sub-status-inactive">
                                                                    {t("ORDER_SKIPPED")}
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="status-datetime">
                                                            {item.completedDateTime ? moment(item.completedDateTime).format("hh:mm A") : ''}
                                                        </span>
                                                        <span className="status-datetime">
                                                            {item.completedDateTime ? moment(item.completedDateTime).format("Do MMM YYYY") : ''}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="divider"></div>
                                            </>
                                        ))}
                                    </div>
                                </Col>

                                <Col span={11} className="document-container">
                                    {(() => {
                                    const hideEDD = checkIsStatusRestrictionForEdd(selectedStatusDetails);
                                    if (hideEDD) return null;

                                    return (
                                        <>
                                        <span className="status-title">
                                            {!isViewSubmittedDocuments
                                            ? t("EDD & Upload Documents")
                                            : ""}
                                        </span>

                                        {!isViewSubmittedDocuments && (
                                            <Form form={Eddform}>
                                            <div className="edd-section">
                                            <div className="edd-description">
                                                {t(
                                                "Select EDD (Estimated Delivery Date & Time) to keep shipments well-tracked and help us improve faster trackment"
                                                )}
                                            </div>
                                            <div className="edd-input-container">
                                        <Form.Item
                                            name="eddDate"
                                            label={
                                            <>
                                                {t("Date & Time")} <span className="required"></span>
                                            </>
                                            }
                                            rules={[
                                            {
                                                required: true,
                                                message: t("Please select Estimated Delivery Date & Time"),
                                            },
                                            ]}
                                            labelCol={{ span: 24 }}
                                        >
                                            <DatePicker
                                                showTime={{ format: "h:mm A"}}
                                                format={format}
                                                className="edd-date-picker"
                                                value={eddValue ? dayjs.utc(eddValue): null}
                                                onChange={(date) =>{onChangeSelectedEDD(date)}}
                                                disabled={isViewSubmittedDocuments}
                                                placeholder={t("Select Date & Time")}
                                                style={{ width: "100%" }}
                                                disabledDate={disabledPastDate}
                                                allowClear={false}
                                                disabledTime={(current) => {
                                                    if (!current) return {};
                                                    const isToday = current.isSame(moment(), "day");

                                                    if (!isToday) return {};

                                                    const currentHour = moment().hour();
                                                    const currentMinute = moment().minute();

                                                    return {
                                                    disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
                                                    disabledMinutes: () =>
                                                        current.isSame(moment(), "hour")
                                                        ? Array.from({ length: currentMinute }, (_, i) => i)
                                                        : [],
                                                    };
                                                }}
                                                />
                                                </Form.Item>
                                            </div>
                                            </div>
                                            </Form>
                                        )}
                                        </>
                                    );
                                    })()}
                                    <div className="select-status">
                                       
                                        <span className="status-title">{isViewSubmittedDocuments ? selectedStatusDetails?.status?.statusName : t("ORDER_SELECT_STATUS")}</span>
                                        {!isViewSubmittedDocuments && <span className="status-description">{t("ORDER_MARK_COMPLETE_STATEMENT")}</span>}
                                    </div>
                                    <div className="upload-container">
                                        <div className="upload-container-title" >
                                            <span className="upload-title" >{t("ACCOUNT_DOCUMENTS")}</span>
                                            {!statusList[currentStatusIndex + 1]?.isCompleted || !isViewSubmittedDocuments && !checkIsInternalSourcing(user?.userRole) &&
                                                <span className="add-docs" onClick={addDocHandler}>{t("ADD_DOC_KEY")} +</span>
                                            }
                                            {isUploadMode && <span className="add-docs" onClick={addDocHandler}>{t("ADD_DOC_KEY")} +</span>}
                                        </div>

                                        {(!addDocs[0]?.documentPath && checkIsInternalSourcing(user?.userRole)) ? ""
                                            :
                                            <Row className="upload-docs-contain">
                                                {addDocs?.map((item, index) => (
                                                    <Col span={11}>
                                                        {/* {!statusList[currentStatusIndex + 1]?.isCompleted || !isViewSubmittedDocuments && !checkIsInternalSourcing(user?.userRole) &&
                                                            <Row justify={'end'} className='remove-docs' onClick={() => setAddDocs(addDocs.filter((item, i) => i !== index))}>
                                                                <CloseOutlined />
                                                            </Row>
                                                        } */}
                                                        {(
                                                        (isUploadMode && item.documentPath) ||
                                                        (!isViewSubmittedDocuments &&
                                                            !checkIsInternalSourcing(user?.userRole))
                                                        ) && (
                                                        <Row
                                                            justify="end"
                                                            className="remove-docs"
                                                            onClick={() =>
                                                            setAddDocs(addDocs.filter((item, i) => i !== index))
                                                            }
                                                        >
                                                            <CloseOutlined />
                                                        </Row>
                                                        )}

                                                        <Fileupload
                                                            filetype={DocTypes.ORDTRPINF}
                                                            defaultThumbFile={item.documentPathThumb}
                                                            defaultFile={item.documentPath}
                                                            fileName={item.fileName}
                                                            entityType={EntityTypes.Inquiry}
                                                            accessFile={true}
                                                            // reUpload={true}
                                                            delete={checkIsInternalSourcing(user?.userRole) || (statusList[selectedStatusDetails?.index]?.documentStatus !== "Rejected" && isViewSubmittedDocuments) ? false : true}
                                                            onChange={(value) => onFileUploadDocs(value, index)}
                                                        />
                                                    </Col>
                                                ))}
                                            </Row>
                                        }

                                        {/* <span className="upload-container-desc">
                                            {selectedStatusDetails?.status && selectedStatusDetails?.index !== currentStatusIndex + 1 ?
                                                selectedStatusDetails?.status?.milestoneDisplayText : !checkIsInternalSourcing(user?.userRole) && (
                                                    <>
                                                { isViewSubmittedDocuments
                                                ?<><img src={infoicon}></img> <span className="document-status">Documents are pending for approval</span></>
                                                : <>On approval, you will be credited <b>20% of the Base Freight</b> charge, i.e., 200 AED, in your MoXey account.</>
                                                }
                                                </>

                                                )}
                                        </span> */}
                                        <span className="upload-container-desc">
                                            {selectedStatusDetails?.status && selectedStatusDetails?.index !== currentStatusIndex + 1 ? selectedStatusDetails?.status?.milestoneDisplayText
                                                : ((orderDetails?.moveType === "Cross Border" && ["Completed loading", "At origin border", "At Destination Border", "Completed"].includes(selectedStatusDetails?.status?.statusName))
                                                    || (orderDetails?.moveType === "Domestic" && ["Completed loading", "Completed"].includes(selectedStatusDetails?.status?.statusName))) &&
                                                <>
                                                    {/* {t("DOC_APPROAVAL_MSG_ONE")} <b>{t("DOC_APPROAVAL_MSG_TWO")}</b>  {t("DOC_APPROAVAL_MSG_THREE")} */}
                                                    {selectedStatusDetails?.status?.milestoneDisplayText }
                                                </>
                                            }
                                            <div className={`document-status-wrapper ${selectedStatusDetails?.status?.documentStatus === OrderDocStatus.PENDING_DOC ? 'pending-status'
                                                : selectedStatusDetails?.status?.documentStatus === OrderDocStatus.REJECTED_DOC ? 'reject-status'
                                                    : selectedStatusDetails?.status?.documentStatus === OrderDocStatus.APPROVED_DOC ? 'booked-status'
                                                        : ""}`}
                                            >
                                                {statusList[selectedStatusDetails?.index]?.documentStatus == null ? ""
                                                    : statusList[selectedStatusDetails?.index]?.documentStatus === OrderDocStatus.PENDING_DOC ? <img src={pendingInfoIcon}></img>
                                                        : statusList[selectedStatusDetails?.index]?.documentStatus === OrderDocStatus.REJECTED_DOC ? <img src={rejectedInfoIcon}></img>
                                                            : statusList[selectedStatusDetails?.index]?.documentStatus === OrderDocStatus.APPROVED_DOC ? <img src={successInfoIcon}></img>
                                                                : <img src={infoicon}></img>
                                                }
                                                {selectedStatusDetails?.status && selectedStatusDetails?.index !== currentStatusIndex + 1 &&
                                                    selectedStatusDetails?.status?.documentStatus === OrderDocStatus.PENDING_DOC ? t("ORDERS_DOC_PENDING_MSG") :
                                                    selectedStatusDetails?.status?.documentStatus === OrderDocStatus.APPROVED_DOC ? t("ORDERS_DOC_APPROVED_SUCC_MSG") :
                                                        selectedStatusDetails?.status?.documentStatus === OrderDocStatus.REJECTED_DOC ? t("ORDERS_DOC_REJECTED_MSG") : ""
                                                }
                                            </div>
                                        </span>
                                    </div>
                                    {(!checkIsInternalSourcing(user?.userRole) && !(statusList[selectedStatusDetails?.index]?.documentStatus !== "Rejected" && isViewSubmittedDocuments)) &&
                                        <div>
                                            <Button type="secondary" loading={uploadStatusLoader} onClick={statusSubmitHandler}
                                                className={`status-btn${((statusList[selectedStatusDetails?.index]?.documentStatus == "Rejected" && (addDocs?.some(z => !z.documentPath) || addDocs?.filter(z => z.isInsertUpdate)?.length == 0))
                                                    || (statusList[selectedStatusDetails?.index]?.documentStatus != "Rejected" && (!statusList[selectedStatusDetails?.index]?.isCompleted ||
                                                        isViewSubmittedDocuments || (statusList[selectedStatusDetails?.index]?.isMust && addDocs?.some(z => !z.documentPath)))))
                                                    ? '-disabled'
                                                    : ''
                                                    }`}
                                                disabled={
                                                    (statusList[selectedStatusDetails?.index]?.documentStatus == "Rejected" && (addDocs?.some(z => !z.documentPath) || addDocs?.filter(z => z.isInsertUpdate)?.length == 0))
                                                    || (statusList[selectedStatusDetails?.index]?.documentStatus != "Rejected" && (!statusList[selectedStatusDetails?.index]?.isCompleted ||
                                                        isViewSubmittedDocuments || (statusList[selectedStatusDetails?.index]?.isMust && addDocs?.some(z => !z.documentPath))))
                                                }
                                            >
                                                {statusList[selectedStatusDetails?.index]?.isCompleted ? t("ORDER_DOCUMENT_MARK_COMPLETE") : t("ORDER_STATUS_TO_PROCEED")}
                                            </Button>

                                            {!statusList[currentStatusIndex + 1]?.isMust &&
                                                <span className="skip-status" onClick={() => setCurrentStatusIndex(currentStatusIndex + 1)}>{t("ORDER_NEXT_STATUS")}</span>
                                            }
                                        </div>
                                    }

                                    {
                                    isUploadMode && (
                                        <Button
                                        type="secondary"
                                        className={`status-btn ${isDisabledSubmit ? "status-btn-disabled" : ""}`}
                                        disabled={isDisabledSubmit}
                                        style={{ width: "100%" }}
                                        loading={statusDocUpdateLoader}
                                        onClick={submitHandlerStatus}
                                        >
                                        Submit
                                        </Button>
                                    )
                                    } 
                                </Col>
                            </Row>
                        }
                    </div>
                </Col>

                {/* right side */}
                <Col span={8} className="right-side-container">
                    <div className="right-side-title">{t("ORDER_LINE_ITEM_DOC")}</div>
                    {(lineItemLoader || orderDetailLoader) ?
                        <div className="loader">
                            <Spin />
                        </div>
                        :
                        (orderDetails && lineItems?.length > 0) ? lineItems?.map((item, index) => (
                            <div className="right-card-container">
                                <Row className="card-first-row">
                                    <Col span={20} className="card-type">{item.category ?? "NA"}
                                        <span className="card-subtype">{item.subCategory ?? "NA"}</span></Col>
                                    {/* <Col span={4}><span className="card-edit-btn" onfClick={() => handleEditClick(item)}><img src={editNotebook} alt="Edit" />Edit</span></Col> */}
                                </Row>
                                <Row className="card-second-row">
                                    <Col span={8} className="unit-price-col">
                                        <span>{t("ORDER_UNIT_PRICE")}</span>
                                        <span className="unit-price-value" style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: 'block',

                                            width: '100px',
                                        }}>
                                            {item.selectedCurrency}{" "}
                                            {item.price ? <DecimalFormatter amount={item?.price} fontSize={"13px"} country={checkIsTurkeyKazak(orderDetails?.operatingCountry) ? "TRY" : item.selectedCurrency} flag={false} isShowDecimal={true}/> : 0}
                                        </span>
                                    </Col>
                                    <Col span={8} className="total-col">
                                        <div>{t("HOME_TOTAL")}</div>
                                        <div
                                        >
                                            <Popover
                                                content={
                                                    <span className="value-LI-doc">
                                                        {item.selectedCurrency}{" "}
                                                        <DecimalFormatter
                                                            amount={item?.totalPrice}
                                                            fontSize={"13px"}
                                                            country={checkIsTurkeyKazak(orderDetails?.operatingCountry) ? "TRY" : item.selectedCurrency}
                                                            flag={false}
                                                            isShowDecimal={true}
                                                        />
                                                    </span>
                                                }
                                                overlayStyle={{ maxWidth: 200 }}
                                            >
                                                <div style={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    display: 'block',
                                                    width: '90px',
                                                }} className="value-LI-doc">
                                                    {item.selectedCurrency}{" "}
                                                    {item.totalPrice ? <DecimalFormatter amount={item?.totalPrice} fontSize={"13px"} country={checkIsTurkeyKazak(orderDetails?.operatingCountry) ? "TRY" : item.selectedCurrency} flag={false} isShowDecimal={true}/> : 0}
                                                </div>
                                            </Popover>

                                            {/* <div className="value-LI-doc">{item.selectedCurrency}{" "}
                                            {item.totalPrice ? <DecimalFormatter amount={item?.totalPrice} fontSize={"13px"} country={checkIsTurkeyKazak(orderDetails?.operatingCountry) ? "TRY" : item.selectedCurrency} flag={false} /> : 0}
                                        </div> */}
                                        </div>
                                        {/* <span>{item.totalPrice ?? 0}</span> */}
                                    </Col>
                                    <Col span={8} className="quantity-col">
                                        <span>{t("ORDER_QUANTITY")}</span>
                                        <span>{item.quantity ?? 0}</span>
                                    </Col>
                                </Row>
                                <Row className="line-upload-docs-contain">
                                    {item?.document?.map((item, index) => (
                                        <Col span={8} className="line-doc-row">
                                            <Fileupload
                                                filetype={DocTypes.ORDTRPINF}
                                                defaultThumbFile={item.documentPathThumb}
                                                defaultFile={item.documentPath}
                                                fileName={item.fileName}
                                                entityType={EntityTypes.Inquiry}
                                                accessFile={true}
                                                // reUpload={true}
                                                delete={false}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                                {!checkIsInternalSourcing(user?.userRole) &&
                                    <Row className="card-button-row">
                                        <button onClick={() => onClickUploadHandler(item)} className="Upload-btn-rts">
                                            {t("ORDER_UPLOAD")} <img src={uploadArrow} alt="Upload" />
                                        </button>
                                    </Row>
                                }
                                <div className={`document-status-wrapper ${item?.lineItemDocStatus === OrderDocStatus.PENDING_DOC_LINE_STATUS ? 'pending-status'
                                    : item?.lineItemDocStatus === OrderDocStatus.REJECTED_DOC ? 'reject-status'
                                        // : item?.lineItemDocStatus === OrderDocStatus.APPROVED_DOC ? 'booked-status' : ""}`}
                                        : OrderDocStatus.APPROVED_DOC.includes(item?.lineItemDocStatus) ? 'booked-status' : ""}`}
                                >
                                    {item?.lineItemDocStatus == null ? ""
                                        : item?.lineItemDocStatus === OrderDocStatus.PENDING_DOC_LINE_STATUS ? <img src={pendingInfoIcon}></img>
                                            : item?.lineItemDocStatus === OrderDocStatus.REJECTED_DOC ? <img src={rejectedInfoIcon}></img>
                                                : <img src={infoicon}></img>
                                    }
                                    {item?.lineItemDocStatus === OrderDocStatus.PENDING_DOC_LINE_STATUS ? t("ORDERS_DOC_PENDING_MSG")
                                        // : item?.lineItemDocStatus === OrderDocStatus.APPROVED_DOC ? t("ORDERS_DOC_APPROVED_SUCC_MSG")
                                        : OrderDocStatus.APPROVED_DOC.includes(item?.lineItemDocStatus) ? t("ORDERS_DOC_APPROVED_SUCC_MSG")
                                            : item?.lineItemDocStatus === OrderDocStatus.REJECTED_DOC ? t("ORDERS_DOC_REJECTED_MSG") : ""
                                    }
                                </div>
                            </div>
                        ))
                            :
                            <div className="no-data">
                                <img src={NodataImg} alt='no data' />
                            </div>
                    }
                </Col>
            </Row>

            {editModel && (
                <>
                    <div className="overlay" onClick={closeModal}></div>
                    <div className="editModel">
                        <div className="editModel-firstrow">
                            <span className="edit-details">{t("ACCOUNT_EDIT_DETAILS")}</span>
                            <span className="cancle-btn" onClick={closeModal}><img src={cancle} alt="close" /></span>
                        </div>
                        <div className="editModel-mainContainer">
                            <Row className="maincontainer-firstRow">
                                <Col className="mainContainer-type">{selectedItem.type}</Col>
                                <Col className="mainContainer-subtype">{selectedItem.subtype}</Col>
                            </Row>
                            <Row className="mainContainer-secondRow">
                                <Col>
                                    <span className="Current-Unit-Price">{t("ORDER_CURRENT_UNIT_PRICE")}</span>
                                    <span>{selectedItem.unitPrice}</span>
                                </Col>
                                <Col >
                                    <span className="Total-Price">{t("ORDER_TOTAL_PRICE")}</span>
                                    <span>{selectedItem.total}</span>
                                </Col>
                                <Col >
                                    <span className="Quantity">{t("ORDER_QUANTITY")}</span>
                                    <span>{selectedItem.quantity}</span>
                                </Col>
                            </Row>
                            <Row className="input-container">
                                <label className="Unit-price">{t("ORDER_UNIT_PRICE")}</label>
                                <span className="currency-prefix">{t("ORDER_AED")}</span>
                                <input type="text" className="custom-input" value={value} onChange={handleChange} />
                            </Row>
                        </div>
                        <Row className="button-row">
                            <Button className="cancel-btn" onClick={closeModal}>{t("ORDER_CLOSE")}</Button>
                            <Button type="secondary" className="submit-btn">{t("COMMON_SAVE_BTN")}</Button>
                        </Row>
                    </div>
                </>
            )}

            {lineItemUploadModal &&
                <Modal className="upload-modal" centered
                    title={<div style={{ fontWeight: 'bold', fontSize: '20px' }}>{t("HOME_DOC_UPLOAD")}</div>}
                    open={lineItemUploadModal}
                    onCancel={() => setLineItemUploadModal(false)}
                    footer={null}
                >
                    <div className="modal-container">
                        <div className="upload-container">
                            <div className="upload-container-title" >
                                <span span={20} className="card-type">{selectedLineItems.category ?? "NA"}
                                    <span className="card-subtype">{selectedLineItems.subCategory ?? "NA"}</span>
                                </span>
                                <span className="add-docs" onClick={addLineDocHandler} >{t("ORDER_ADD_DOC")}+</span>
                            </div>
                            <Row className="upload-docs-contain">
                                {addLineDocs?.map((item, index) => (
                                    <Col span={12} className="upload-doc">
                                        <Row justify={'end'} className='remove-docs' onClick={() => setAddLineDocs(addLineDocs.filter((item, i) => i !== index))}>
                                            <CloseOutlined />
                                        </Row>
                                        <Fileupload
                                            filetype={DocTypes.ORDTRPINF}
                                            defaultThumbFile={item.documentPathThumb}
                                            defaultFile={item.documentPath}
                                            fileName={item.fileName}
                                            entityType={EntityTypes.Inquiry}
                                            reUpload={true}
                                            accessFile={true}
                                            delete={checkIsInternalSourcing(user?.userRole) ? false : true}
                                            onChange={(value) => onFileUploadLineItemdocs(value, index)}
                                        />
                                    </Col>
                                ))}
                            </Row>
                            <div className={`document-status-wrapper ${selectedLineItems?.lineItemDocStatus === OrderDocStatus.PENDING_DOC_LINE_STATUS ? 'pending-status'
                                : selectedLineItems?.lineItemDocStatus === OrderDocStatus.REJECTED_DOC ? 'reject-status'
                                    : selectedLineItems?.lineItemDocStatus === OrderDocStatus.APPROVED_DOC ? 'booked-status' : ""}`}
                            >
                                {selectedLineItems?.lineItemDocStatus == null ? ""
                                    : selectedLineItems?.lineItemDocStatus === OrderDocStatus.PENDING_DOC_LINE_STATUS ? <img src={pendingInfoIcon}></img>
                                        : selectedLineItems?.lineItemDocStatus === OrderDocStatus.REJECTED_DOC ? <img src={rejectedInfoIcon}></img>
                                            : selectedLineItems?.lineItemDocStatus === OrderDocStatus.APPROVED_DOC ? <img src={successInfoIcon}></img>
                                                : <img src={infoicon}></img>
                                }
                                {selectedLineItems?.lineItemDocStatus === OrderDocStatus.PENDING_DOC_LINE_STATUS ? t("DOC_PENDING_FOR_APPROVAL_MSG")
                                    : selectedLineItems?.lineItemDocStatus === OrderDocStatus.APPROVED_DOC ? t("DOC_APPROVED_MSG")
                                        : selectedLineItems?.lineItemDocStatus === OrderDocStatus.REJECTED_DOC ? t("DOC_REJECTED_MSG")
                                            : ""
                                }
                            </div>
                        </div>

                        <div className="mobile-change-footer">
                            <Button className="cancel-btn" key="cancel" disabled={uploadLoader} onClick={() => setLineItemUploadModal(false)}>
                                {t("COMMON_CANCEL_BTN")}
                            </Button>
                            <Button className="submit-btn" key="submit" type="primary" loading={uploadLoader} onClick={SaveLineItemDocsHandler}>
                                {t("SIGNUP_KYC_SUBMIT_BTN")}
                            </Button>
                        </div>
                    </div>
                </Modal>
            }
        </div>
    )
}

export default DocumentStatus;